<div class="card card-custom gutter-b" id="all-notifications">
    <div class="card-header border-0 py-6 px-9">
        <div class="card-title">
            <h3 class="card-label">Notifications</h3>
        </div>
    </div>

    <div class="card-body">

        <div class="blue-bar">
            <span>{{numberOfNewNotifications}} notifications unread</span>
            <div ngbDropdown container="body" class="d-inline-block">
                <i class="fas fa-ellipsis-h cursor-pointer" id="actionOption" ngbDropdownToggle></i>
                <div ngbDropdownMenu aria-labelledby="actionOption" class="notification-options">
                    <span class="d-flex align-items-center cursor-pointer" ngbDropdownItem
                          (click)="markAllAsRead()">
                        <i class="fas fa-check-double option-icon mr-2"></i>
                        Mark all as Read
                    </span>

                    <span class="d-flex align-items-center cursor-pointer" ngbDropdownItem
                          (click)="clearAllNotification()">
                        <i class="fas fa-trash option-icon mr-2"></i>
                        Clear notifications
                    </span>

                    <span class="d-flex align-items-center cursor-pointer" ngbDropdownItem>
                        <i class="fas fa-cog option-icon mr-2"></i>
                        Settings
                    </span>
                </div>
            </div>
        </div>

        <div class="notification-content"
             infiniteScroll
             [infiniteScrollDistance]="1"
             [infiniteScrollThrottle]="150"
             (scrolled)="onScroll()">
            <div class="item-element mb-1" *ngFor="let notification of allNotifications"
                 [ngClass]="notification.status === 'new' ? 'status-new' : ''">

                <a (click)="markOneAsRead(notification.id)" class="item-link"
                   [routerLink]="notification.type === 'leaveRequest' ? '/days-off/view/' + notification.link :
                         notification.type === 'ticket' ? '/tickets/view/' + notification.link :
                         notification.type === 'procedure' ? '/procedures/' + notification.link :
                         notification.type === 'directive' ? '/directives/' + notification.link :
                         notification.type === 'project' ? '/projects/' + notification.link : ''">

                    <i class="fas item-icon"
                       [ngClass]="notification.category === 'HR' ? 'fa-chart-pie' :
                          notification.category === 'CRM' ? 'fa-users' :
                          notification.category === 'ERP' ? 'fa-headset' :
                          notification.category === 'user' ? 'fa-info-circle' : ''">
                    </i>

                    <span class="link-content">
                        <span class="name">
                            {{notification.title}}
                        </span>
                        <span class="date">
                            {{notification.createdAt}}
                        </span>
                    </span>
                </a>

                <div class="notification-options">
                    <div ngbDropdown container="body" class="d-inline-block">
                        <i class="fas fa-ellipsis-h cursor-pointer" id="actionOption2" ngbDropdownToggle></i>
                        <div ngbDropdownMenu aria-labelledby="actionOption2" class="notification-options">
                            <span class="d-flex align-items-center cursor-pointer" ngbDropdownItem
                                  (click)="markOneAsRead(notification.id)">
                             <i class="fas fa-check option-icon mr-2"></i>
                             Mark as Read
                            </span>

                            <span class="d-flex align-items-center cursor-pointer" ngbDropdownItem
                                  (click)="clearOneNotification(notification.id)">
                             <i class="fas fa-trash option-icon mr-2"></i>
                                Clear notification
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="no-notifications" *ngIf="allNotifications.length === 0">
            <span>There are no notifications at the moment.</span>
        </div>
    </div>
</div>
